import React from 'react';
import { Image } from 'react-bootstrap';

import './navBar.css';

const NavBar = ({ logo }) => {
  return (
    <div className="nav-bar__container">
      <div className="nav-bar__horizontal-line">
        <div className="nav-bar__icon">
          <Image className="nav-bar__image" src={logo} />
        </div>
        <div className="nav-bar__title"></div>
        <div className="nav-bar__button"></div>
      </div>
    </div>
  );
};

export default NavBar;
